import React from 'react';
import { Link } from 'react-router-dom'; // Assuming usage within react-router
import { FaInstagram, FaTwitter, FaTiktok } from 'react-icons/fa';
import './Footer.css'; // Import the CSS file

const Footer = () => {
  const navSections = [
    {
      id: 'footer-company',
      title: 'Company',
      links: [
        { name: 'About Fably', href: 'https://www.fably.fun/#' },
        { name: 'Features', href: 'https://www.fably.fun/#' },
        { name: 'How it Works', href: 'https://www.fably.fun/#' },
        { name: 'Careers', href: 'https://www.fably.fun/#' },
      ],
    },
    {
      id: 'footer-video-styles',
      title: 'Video Styles',
      links: [
        { name: 'Ghibli Style', href: '/dreamy-style' },
        { name: 'No lineart', href: '/no-lineart' },
      ],
    },
    {
      id: 'footer-legal',
      title: 'Legal',
      links: [
        { name: 'Privacy Policy', href: '/policy' },
        { name: 'Terms & Conditions', href: '/terms' },
        { name: 'Refund Policy', href: '/refund-policy' },
      ],
    },
  
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Left Section */}
          <div className="footer-left-section">
            <Link to="/">
              <img 
                src="/logonavbar.png" // Use root-relative path for public folder
                alt="Magical Videos logo" 
                className="footer-logo"
              />
            </Link>
            <p className="footer-tagline">
              Become the studio.
            </p>
            <div className="footer-social-links">
              <a href="https://instagram.com/YOUR_PROFILE" aria-label="Instagram" rel="noopener noreferrer" className="social-icon instagram">
                <FaInstagram />
              </a>
              <a href="https://twitter.com/dotdotdotd1" aria-label="Twitter" rel="noopener noreferrer" className="social-icon twitter">
                <FaTwitter />
              </a>
              <a href="https://tiktok.com/@fablystudio" aria-label="TikTok" rel="noopener noreferrer" className="social-icon tiktok">
                <FaTiktok />
              </a>
            </div>
          </div>

          {/* Navigation Columns */}
          {navSections.map((section) => (
            <div key={section.id} className="footer-nav-column">
              <nav aria-labelledby={section.id}>
                <h2 id={section.id} className="sr-only">{section.title}</h2>
                <p className="footer-nav-title">{section.title}</p>
                <ul className="footer-nav-list">
                  {section.links.map((link) => (
                    <li key={link.name} className="footer-nav-item">
                      <Link 
                        to={link.href} 
                        className="footer-nav-link"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom-bar">
          <p>
            © Copyright 2025 Fably
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 